const getCheckoutLink = ({ language, organization }) => {
  switch (language) {
    case 'en':
      return `https://piwik.pro/pricing/?account=${organization}`;
    case 'de':
      return `https://piwikpro.de/preise/?account=${organization}`;
    case 'fi':
      return `https://piwik.pro/pricing/?account=${organization}`;
    case 'fr':
      return `https://piwikpro.fr/pricing/?account=${organization}`;
    case 'nl':
      return `https://piwikpro.nl/piwik-pro-pakketten/?account=${organization}`;
    case 'se':
      return `https://piwik.pro/pricing/?account=${organization}`;
    default:
      return `https://piwik.pro/pricing/?account=${organization}`;
  }
};

export default getCheckoutLink;
